import React, { Component } from 'react';
import './TestExplain.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class TestExplain extends Component {
  componentDidMount() {
    const coll = document.getElementsByClassName('collapsible');
    let i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function() {
        this.classList.toggle('active');
        var content = this.nextElementSibling;
        if (content.style.display === 'block') {
          content.style.display = 'none';
        } else {
          content.style.display = 'block';
        }
      });
    }
  }

  render() {
    return (
      <div className="test-explain mt-2">
        <h1>Gyakori kérdések</h1>

        <button className="collapsible">
          <span>Milyen az ideális eredmény? </span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <p>
            Nincs ideális eredmény. Az élethelyzetedtől függ, hogy melyik konfliktuskezelési stílus
            a célravezető. Ha viszont úgy látod, hogy a stílusod nem felel meg azoknak a
            helyzeteknek, amikkel találkozol, akkor érdemes gondolkodni a helyzetek megváltoztatásán
            - pl. munkahely váltás.
          </p>
        </div>

        <button className="collapsible">
          <span>Mit jelentenek az értékek ebben a tesztben?</span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <div>
            Amelyik stílus magasabb értéket kapott, azt szívesebben és többször alkalmazod, mint
            azt, amelyik alacsonyat. Az értékek sokszor egyfajta sorrendet is jelentenek – egy
            konfliktushelyzetben a magasabb értéket kapott stílustól haladsz az alacsonyabb érték
            felé.
            <br />
            <br />
            Példák:
            <ol>
              <li>
                Először inkább elkerülöd a konfliktust, ha ez nem lehetséges akkor problémamegoldó
                stílusra váltasz, ha ez sem megy, akkor kompromisszumot kötsz vagy alkalmazkodsz.{' '}
              </li>
              <li>
                Először alkalmazkodsz, de ha a helyzet elviselhetetlen, akkor megpróbálod a
                problémamegoldó vagy kompromisszumkereső stílust. Ha a helyzet elviselhetetlen,
                domináns stílusra váltasz.
              </li>
              <li>
                Először dominánsan viselkedsz de ha erős ellenállást tapasztalsz, problémamegoldó
                majd kompromisszumkereső stílusra váltasz.
              </li>
            </ol>
          </div>
        </div>

        <button className="collapsible">
          <span>
            Az egyik stílus nálam nagyon alacsony értéket kapott – ezt a stílust nem is tudom
            alkalmazni?
          </span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <p>
            Azt a stílust is tudod alkalmazni, ami alacsony vagy nulla értéket kapott. Azonban
            lehetséges, hogy ritkán vagy nem szívesen alkalmazod azt. Éppen itt segíthet a tudatos
            átgondolás: ha úgy véled, hogy erre a stílusra van szükséged, dominánsként is lehetsz
            alkalmazkodó vagy elkerülőként is lehetsz domináns. Alkalmazni tudod bármelyik stílust,
            bár lehet, hogy az, amelyik alacsony értéket kapott, nehezebben megy neked.{' '}
          </p>
        </div>

        <button className="collapsible">
          <span>
            Úgy tűnik, ellentmondásos az eredményem. Egyszerre magas a domináns és az
            elkerülő stílus. Hogyan lehetséges ez?
          </span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <p>
            A domináns és elkerülő vagy a domináns és alkalmazkodó egyidejű magas értéke sokszor
            előfordul. Azt a viselkedést írja le, hogy a domináns addig marad domináns, amíg esélye
            van a sikerre. Ha ezt az esélyt nem látja, akkor inkább az elkerülő vagy az alkalmazkodó
            magatartást választja – attól függően, hogy mennyire fontos a másik féllel a kapcsolat.
            (Ha nem fontos, akkor inkább elkerülő lesz. Ha fontos, akkor inkább alkalmazkodó.)
          </p>
        </div>

        <button className="collapsible">
          <span>
            A kitöltéskor néha nem tudtam, mit válasszak: eltérő élethelyzetekben eltérően
            viselkedem. Ezért egy konkrét élethelyzetre gondoltam, aszerint választottam. Más
            helyzetben másképp viselkedtem volna. Ez mennyire befolyásolja az eredményt?
          </span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <p>
            A személyiségedhez legközelebb álló eredményt az adja, ha nem gondolsz helyzetekre,
            szimplán csak a mondatokról próbálod eldönteni, hogy melyik áll közelebb hozzád. Próbáld
            meg úgy kitölteni a tesztet, hogy nem gondolsz konkrét helyzetekre. Természetesen lehet
            különbség például otthon és munkahely között. Ezt is érdemes vizsgálni. Ha kíváncsi
            vagy, hogyan viselkedsz eltérő környezetben, töltsd ki a tesztet még egyszer. Gondolj
            például csak munkahelyi helyzetekre vagy csak magánéletiekre és válaszold meg úgy a
            kérdéseket. Az eredmények ekkor jobban tükrözik azt az élethelyzetet, amit választottál.
          </p>
        </div>

        <button className="collapsible">
          <span>Rám nem illik ez a teszt. Én másmilyen vagyok. </span>{' '}
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <p>
            Ez előfordulhat. Minden teszt tévedhet, így te tudod igazán megítélni, milyen is a
            stílusod valójában. Vesd össze az eredményeket a valós viselkedéseddel. A tesztet is
            megismételheted, ha úgy látod jónak.{' '}
          </p>
        </div>

        <button className="collapsible">
          <span>Változhat a konfliktuskezelési stílusom?</span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
        <div className="content">
          <p>
            Igen, változhat. A tapasztalataiddal együtt változik a konfliktuskezelési stílusod is.
            Így néhány év elteltével lehet, hogy megértőbb vagy éppen határozottabb leszel, esetleg
            ügyesebbé válsz a problémamegoldásban.
          </p>
        </div>
      </div>
    );
  }
}

export default TestExplain;
